import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MonPortefeuilleRoutingModule } from './mon-portefeuille-routing.module';
import { MesDossiersComponent } from './mes-dossiers/mes-dossiers.component';
import { TacheEnCoursComponent } from './mes-dossiers/tache-en-cours/tache-en-cours.component';
import { HistoriqueTacheComponent } from './mes-dossiers/historique-tache/historique-tache.component';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { FormulaireModule } from '../formulaire/formulaire.module';
import { MesTachesEnCoursComponent } from './mes-taches-en-cours/mes-taches-en-cours.component';
import { MonHistoriqueDossierComponent } from './mon-historique-dossier/mon-historique-dossier.component';


@NgModule({
  imports: [
    CommonModule,
    MonPortefeuilleRoutingModule,
    SharedModule,
    ParametrageModule,
    FormulaireModule
  ],
  declarations: [
    MesDossiersComponent,
    TacheEnCoursComponent,
    HistoriqueTacheComponent,
    MesTachesEnCoursComponent,
    MonHistoriqueDossierComponent,
  ],
    
  providers: [
  ],

  entryComponents: [
  ]
})
export class MonPortefeuilleModule { }
